import * as React from 'react';
import { Grid, Typography } from '@mui/material';
import { IResourceTypeViewModel } from 'Interfaces/IResourcesConfig';
import { GetColorByName } from 'functions/GetColorByName';

type Props = {
  resourceType: IResourceTypeViewModel;
  
};

export const SingleResourceTypeView = ({ resourceType }: Props) => {
 
  return (
    <Grid
      container
      direction={'row'}
      sx={{
        mb: 1,
        p: 1,
        borderLeft: 8,
        borderRadius: 2,
        backgroundColor: 'primary.main',
        boxShadow: '0px 2px 5px 0px rgba(0,0,0,0.50)',
        borderColor: GetColorByName(`${resourceType.name}`).background,
        height: 36,
        ':hover': {
          cursor: 'pointer',
          filter: 'brightness(120%)',
          transition: 'all 0.2s ease-in-out',
        },
      }}
    >
      <Grid item xs={6}>
        <Typography
          sx={{
            m: 0,
            textAlign: 'left',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontWeight: 'bold',
            letterSpacing: 2,
            fontSize: 14,
          }}
        >
          {resourceType.name}
        </Typography>
      </Grid>

      <Grid item xs={6}>
        <Typography
          sx={{
            m: 0,
            textAlign: 'left',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            fontWeight: 'bold',
            letterSpacing: 2,
            fontSize: 14,
          }}
        >
          {resourceType.note.length >  0 ? resourceType.note : 'Ingen notat'}
        </Typography>
      </Grid>
    </Grid>
  );
};
